/* eslint-disable css-modules/no-unused-class */
import cx from 'classnames';

// Design System
import SaleTagIcon from 'jl-design-system/elements/icons-jb/SaleTag32PxOutlined';

// Types
import { GiftOptionProps } from './GiftOption.types';

// Config
import { GIFT_OPTIONS } from '@constants/giftOptionsConstants';

// Styles
import styles from './gift-option.scss';

const GiftOption = ({
  dataTest,
  giftOptionClassName,
  onClick = () => {},
  showNewPromoCodeOption,
  type,
}: GiftOptionProps) => {
  const promoCodeIcon = type === GIFT_OPTIONS.PROMO_CODE ? <SaleTagIcon className={styles.saleTagIcon} /> : undefined;

  return (
    <button className={styles.button} data-testid={dataTest} onClick={onClick} type="button">
      <div className={styles[giftOptionClassName]} data-testid="gift-option-classname">
        <span
          className={cx(styles.buttonText, {
            [styles.buttonTextNewPromoCode]: showNewPromoCodeOption,
          })}
        >
          {promoCodeIcon && promoCodeIcon}
          {type}
        </span>
      </div>
    </button>
  );
};

export default GiftOption;
